import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject } from '@costar-ui/cosmos';
import spacingOptions from '../space-options/spacing-options.esm.js';

var flexAutoSizingComponentVariant = getTvObject([{
  direction: 'horizontal',
  canShrink: true,
  className: ['min-w-0', 'shrink', 'grow']
}, {
  direction: 'vertical',
  canShrink: true,
  className: ['min-h-0', 'shrink', 'grow']
}]);
var enableScrollingComponentVariant = getTvObject([{
  direction: 'horizontal',
  scrollable: true,
  className: ['overflow-x-auto', 'print:overflow-visible']
}, {
  direction: 'vertical',
  scrollable: true,
  className: ['overflow-y-auto', 'print:overflow-visible']
}]);
var flexOptions = getTvObject({
  base: ['relative', 'flex', 'print:flex-none'],
  variants: _objectSpread2({
    canShrink: {
      "true": []
    },
    direction: {
      horizontal: 'flex-row',
      vertical: 'flex-col'
    },
    fullWidth: {
      "true": 'w-full'
    },
    fullHeight: {
      "true": 'h-full'
    },
    stretch: {
      "true": 'grow'
    },
    inline: {
      "true": 'inline-flex'
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      evenly: 'justify-evenly',
      between: 'justify-between',
      stretch: 'justify-stretch',
      around: 'justify-around'
    },
    alignItems: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      baseline: 'items-baseline',
      stretch: 'items-stretch'
    },
    scrollable: {
      "true": []
    }
  }, spacingOptions),
  compoundVariants: [].concat(_toConsumableArray(flexAutoSizingComponentVariant), _toConsumableArray(enableScrollingComponentVariant))
});

export { flexOptions as default, enableScrollingComponentVariant, flexAutoSizingComponentVariant };
//# sourceMappingURL=flex-options.esm.js.map
